export default {"src":"/_next/static/media/discover.13dab60b.svg","height":24,"width":35,"blurWidth":0,"blurHeight":0};